/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import produce from 'immer';
import moment from 'moment';
import { Reducer } from 'redux';

import { WIZARD_STORAGE_CLEAR_STEPS } from '@/main/modules/wizard/wizardConstants';

import { EFormatData } from '../PageDashboard/types/widgetTypes';
import { TWizardCollationReportActions } from './types/wizardCollationReportActionTypes';
import {
    WIZARD_COLLATION_REPORT_SET_PARAMS,
    WIZARD_COLLATION_REPORT_VALIDATE_FINISH,
    WIZARD_COLLATION_REPORT_VALIDATE_START,
} from './wizardCollationReportConstant';

export interface IWizardCollationReportReducer {
    isStepValid: boolean;
    startDate: string;
    endDate: string;
    formatsAvailable: string[];
    reportFormat: string;
}

export const initialWizardCollationReportState: IWizardCollationReportReducer = {
    isStepValid: true,
    startDate: moment().subtract(1, 'months').startOf('month').format(EFormatData.ReverseData),
    endDate: moment().subtract(1, 'months').endOf('month').format(EFormatData.ReverseData),
    formatsAvailable: [],
    reportFormat: '',
};

const wizardCollationReportReducer: Reducer<IWizardCollationReportReducer, TWizardCollationReportActions> = (
    state = initialWizardCollationReportState,
    action: TWizardCollationReportActions,
) =>
    produce(state, (draft) => {
        switch (action.type) {
            case WIZARD_COLLATION_REPORT_VALIDATE_START:
                break;
            case WIZARD_COLLATION_REPORT_VALIDATE_FINISH:
                draft.isStepValid = action.payload.isStepValid;
                break;

            case WIZARD_COLLATION_REPORT_SET_PARAMS:
                Object.assign(draft, { ...draft, ...action.payload });
                break;

            case WIZARD_STORAGE_CLEAR_STEPS:
                Object.assign(draft, initialWizardCollationReportState);
                break;
        }
    });

export default wizardCollationReportReducer;
